var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.authComponent,{tag:"component",on:{"submit":_vm.submit,"reset":_vm.reset}})
}
var staticRenderFns = []

export { render, staticRenderFns }